module.exports = __WEBPACK_EXTERNAL_MODULE_154__;


//////////////////
// WEBPACK FOOTER
// external "depcheck"
// module id = 154
// module chunks = 0